const yup = require("yup");
const passwordValidation = require("./password.js");
module.exports = passwordValidation.oneOf(
  [yup.ref("newpassword"), null],
  "Passwords do not match"
);
